export default {
  init() {
    // JavaScript to be fired on the about us page


  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    $('.team-member-tile__content__description-wrapper').each(function( index ) {

      var memberContent        = $(this);
      var memberContentWrapper = $(this).find('.team-inner-wrapper');
      var memberContentFade    = $(this).find('.text-fade');
      var descriptionContainer = $(`#team-description-container-${ index }`);
      var descriptionToggle    = $(`#team-description-toggle-${ index }`);
      var teamMemberImage      = $(`#team-member-tile-image-${ index }`);

      function toggleBio () {
        var contentHeight = memberContentWrapper.height();
        var contentState  = memberContent.data( 'state' );

        if ( contentState === 'open' ) {
          memberContent.data( 'state', 'closed' );
          memberContent.css('height', '10rem');

          memberContentFade.css( 'opacity', '1' )
          teamMemberImage.addClass( 'team-member-tile__image-container--masked' );
          descriptionToggle.html('OPEN BIO');
        }

        if ( contentState === 'closed') {
          memberContent.data( 'state', 'open' );
          memberContent.css('height', contentHeight);

          memberContentFade.css( 'opacity', '0' )
          teamMemberImage.removeClass( 'team-member-tile__image-container--masked' );
          descriptionToggle.html('CLOSE BIO');
        }
      }

      descriptionToggle.click(toggleBio);
      descriptionContainer.click(toggleBio);
      teamMemberImage.click(toggleBio);

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js